<div>
  <h1>CUBOS.Connect Version 2.7</h1>
</div>

<div class="wrapper">
  <div class="block" style="background-color: #f1f5f9;">
    <img src="https://www.cubos.com/images/bc11-alpha.webp" alt="CUBOS BC11 Alpha" style="width: 100%;" />
  </div>

  <div class="block" style="border-left: 1px solid #ddd; border-right: 1px solid #ddd;">
    <div class="poster">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="feather feather-charging-station">
        <path d="M3,22V4c0-1.1,0.9-2,2-2h7c1.1,0,2,0.9,2,2v18H3z" />
        <path d="M16,22H1" />
        <path d="M14,9c4,0,3,4,3,8s6,4,6,0s-3-4-3-10" />
        <path d="M22,5c0,0,0,2-2,2s-2-2-2-2h2H22z" />
        <path d="M18,4c0,0.6,0,1,0,1S18,4.6,18,4s0-1,0-1S18,3.4,18,4z" />
        <path d="M22,4c0,0.6,0,1,0,1S22,4.6,22,4s0-1,0-1S22,3.4,22,4z" />
      </svg>
    </div>
    <div class="box">
      <h2>Bidirektionales Laden</h2>
      <p style="font-weight: bold;">
        Mit CUBOS.Connect 2.7 ist es möglich das bidirektionale Laden zwischen E-Auto und Gebäude zu steuern.
        Zum Beispiel können Sie Ihren Strom ins eigene Zuhause oder ins eigene Betriebsnetz einspeisen (V2H).
        Für die Einspeisung ins öffentliche Netz (V2G) müssen wir auf die staatliche Regulatorik warten.
      </p>
      <p>
        Sie benötigen eine Ladestation, die bidirektionales Laden unterstützt.<br />
        Mit unserer BC11 Ladestation und unserem CUBOS.Energy Gateway können Sie ab jetzt bidirektional Laden.
      </p>
      <p>
        <a href="https://www.cubos.com/bidirektionales-laden" target="_blank">
          Erfahren Sie mehr unsere BC11 Ladestation
        </a>
      </p>
    </div>
  </div>

  <div class="block">
    <div class="poster">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="feather feather-sliders">
        <line x1="4" y1="21" x2="4" y2="14"></line>
        <line x1="4" y1="10" x2="4" y2="3"></line>
        <line x1="12" y1="21" x2="12" y2="12"></line>
        <line x1="12" y1="8" x2="12" y2="3"></line>
        <line x1="20" y1="21" x2="20" y2="16"></line>
        <line x1="20" y1="12" x2="20" y2="3"></line>
        <line x1="1" y1="14" x2="7" y2="14"></line>
        <line x1="9" y1="8" x2="15" y2="8"></line>
        <line x1="17" y1="16" x2="23" y2="16"></line>
      </svg>
    </div>
    <div class="box">
      <h2>Intelligente Automatik mit CUBOS.Energy</h2>
      <p>
        Im Automatik-Modus übernimmt CUBOS.Energy die Steuerung der Entlade- und Ladeleistung,
        so dass Ihr Strombezug aus dem öffentlichen Netz minimiert wird und gleichzeitig
        die PV-Eigennutzungsquote erhöht wird.
      </p>
      <p>
        Sie legen lediglich die Grenzen des Batteriestandes fest,
        in dem entladen und geladen werden darf, dann optimiert unser Gateway Ihren Stromverbrauch.
        Sie können die Lade- und Entladeleistung bei Bedarf auch manuell steuern.
      </p>
      <p>
        Kontaktieren Sie uns gerne unter <a href="mailto:support@cubos.com">support@cubos.com</a>,
        wenn Sie wissen möchten, ob Ihr Fahrzeug das bidirektionale Laden unterstützt.
      </p>
      <p>
        <a href="https://www.cubos.com/energiemanagement" target="_blank">
          Erfahren Sie mehr über unser CUBOS.Energy&nbsp;Gateway
        </a>
      </p>
    </div>
  </div>
</div>

<div class="modal-footer d-flex justify-content-between align-items-center">
  <div class="float-start">Version 2.7.9</div>
  <div class="d-flex align-items-center ms-auto">
    <input type="checkbox" id="hideReleaseNotes" [checked]="isHidden" (click)="toggleHidden()"
      class="form-check-input" />
    <label for="hideReleaseNotes" class="form-check-label pt-1 ps-2 d-none d-md-block"
      i18n="@@hideReleaseNotesLabel">Nicht erneut anzeigen</label>
  </div>
  <div>
    <button class="btn btn-yellow" id="release-notes-close" data-bs-dismiss="modal" (click)="onCancelClick()"
      i18n="@@CloseButton">Schließen</button>
  </div>
</div>